/* eslint-disable no-shadow */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
// Dependecies
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// Store
import user from '../../store/user';

function useRadarCharts(plate) {
  const [userStore] = user();
  const [radarData, useSetRadarData] = useState([]);
  const [radarDataDriver, useSetRadarDataDriver] = useState([]);
  const [licensePlate] = useState(plate);
  const [t] = useTranslation('dahsboard', { useSuspense: false });

  // Remove accents and convert to lowercase
  const translateKey = (key, t) => {
    const keyClean = key
    .normalize('NFD') // separates letters from accents
    .replace(/[\u0300-\u036f]/g, '') // removes accent marks
    .toLowerCase();
    return t(keyClean).charAt(0).toUpperCase() + t(keyClean).slice(1);
  };
  
  useEffect(() => {
    if (userStore.token) {
      const getRadar = async () => {
        const jsons = {
          licensePlate,
        };
        const options = {
          method: 'POST',
          body: JSON.stringify(jsons),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `bearer ${userStore.token}`,
          },
        };
        const response = await fetch('/api/bread/jwt/services/static/radar_dashboard', options);
        const newData = await response.json();
        if (response.status === 200) {
          const object = newData.health;


          if (!object || Object.keys(object).length === 0) {
            useSetRadarData([]);
            useSetRadarDataDriver([]);
            return;
          }

          const radarData = [];
          const radarDataDriver = [];
        
          for (const key in object) {
     
            const [score1, score2] = object[key].split(',');
            const translatedType = translateKey(key, t);

            radarData.push({
              type: translatedType,
              score: Number(score1),
            });

            radarDataDriver.push({
              type: translatedType,
              score: Number(score2 ?? 0), // Usa 0 si score2 es undefined o null
            });
          }
        
          useSetRadarData(radarData);
          useSetRadarDataDriver(radarDataDriver);
        }
      };
      getRadar();
    }
  }, [userStore.token, licensePlate]);

  return {
    radarData,
    radarDataDriver,
  };
}

export default useRadarCharts;
